import { Text } from '@trmediaab/zebra';
import { Money } from '@trmediaab/zebra-components';

interface PriceProps {
  price: number;
  reducedPrice: number | null;
  center: boolean;
}

const Price = ({ price, reducedPrice, center }: PriceProps) => (
  <Text
    color={reducedPrice != null ? 'checkout.discount' : undefined}
    fontSize="42px"
    fontWeight={reducedPrice != null ? 'extraBold' : undefined}
    lineHeight="tight"
    textAlign={center ? 'center' : undefined}
  >
    {price > 0 && reducedPrice != null && (
      <>
        <Text.inline
          color="text.primary"
          fontWeight="normal"
          mb="2"
          css={{ textDecoration: 'line-through' }}
        >
          <Money value={price} />
        </Text.inline>{' '}
      </>
    )}

    {price === 0 ? 'Gratis' : <Money value={reducedPrice ?? price} />}
  </Text>
);

export default Price;
